import { Model } from '@/models/Model';
export class LvsSubjectSetting extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'LvsSubjectSetting';
        this.$endpoint = '/lvs-subject-settings';
        this.$fillable = [];
    }
}
